import { useCallback } from "react";
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const useUtils = () => {
  const DATE_TIME_DISPLAY_FORMAT = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }
  const getFormattedDateTime = (time) => {
    const date = firebaseTimestampToDate(time)
    if (date instanceof Date) {
      return new Intl.DateTimeFormat('default', DATE_TIME_DISPLAY_FORMAT).format(date);
    }
    return "Can't parse timestamp"
  }

  const formatTextDate = useCallback((textDate) => {
    return textDate.substring(0,2) + '-' + 
          textDate.substring(2, 5) + '-' + 
          textDate.substring(5, 9);
  }, []);

  const rideIdToDate = useCallback((textDate) => {
    return new Date(parseInt(textDate.substring(5, 9)),
                    months.indexOf(textDate.substring(2, 5)), 
                    parseInt(textDate.substring(0, 2))
    )
  }, []);

  const dateDiffInDays = useCallback((date1Str, date2Str) => {
    const date1 = rideIdToDate(date1Str);
    const date2 = rideIdToDate(date2Str);
    const msDiff = Math.abs(date1.getTime() - date2.getTime());
    return Math.round(msDiff / (24 * 60 * 60 * 1000));
  }, [rideIdToDate]);

  const firebaseTimestampToDate = (timestamp) => {
    if (!timestamp) {
      return null;
    }
    
    // Handle Firestore Timestamp object with toDate() method
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
      return timestamp.toDate();
    }
    
    // Handle serialized timestamp with underscore prefix
    if (timestamp._seconds !== undefined && timestamp._nanoseconds !== undefined) {
      return new Date(timestamp._seconds * 1000 + timestamp._nanoseconds / 1000000);
    }
    
    // Handle serialized timestamp without underscore prefix
    if (timestamp.seconds !== undefined && timestamp.nanoseconds !== undefined) {
      return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
    }
    
    // If already a Date, return it
    if (timestamp instanceof Date) {
      return timestamp;
    }
    
    // If it's a number (milliseconds since epoch)
    if (typeof timestamp === 'number') {
      return new Date(timestamp);
    }
    
    // If it's a string that can be parsed as a date
    if (typeof timestamp === 'string') {
      const parsedDate = new Date(timestamp);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    }
    
    console.warn('Unknown timestamp format:', timestamp);
    return null;
  }


  return {getFormattedDateTime, formatTextDate, rideIdToDate, dateDiffInDays};
}
export { useUtils };